import { useGetAllCountries } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {}
export default function CountryPhoneCodeInput({ ...props }: Props) {
  const { data, isLoading } = useGetAllCountries();

  return (
    <Select
      loading={isLoading}
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.internationalCountryCode}>
            {c.internationalCountryCode}
          </Select.Option>
        );
      })}
    </Select>
  );
}
